import { BlogRole } from './dto';

// WS-UC-6: права ролей в блоге. Общие для API (охранники) и интерфейса
// (скрытие недоступных действий).
export enum BlogPermission {
  /** Читать всё содержимое блога. */
  View = 'view',
  /** Посты, медиа, записи справочников. */
  EditContent = 'edit_content',
  /** Очередь, точное время, перенос и снятие публикаций. */
  Plan = 'plan',
  /** Пакеты, отметка выхода и отмена публикаций. */
  Publish = 'publish',
  /** Настройки блога: каналы, слоты, схемы, статусы, типы сущностей, поля постов. */
  ManageSettings = 'manage_settings',
  /** Участники блога и их роли. */
  ManageMembers = 'manage_members',
}

const VIEWER: readonly BlogPermission[] = [BlogPermission.View];
const EDITOR: readonly BlogPermission[] = [...VIEWER, BlogPermission.EditContent, BlogPermission.Plan, BlogPermission.Publish];
const OWNER: readonly BlogPermission[] = [...EDITOR, BlogPermission.ManageSettings, BlogPermission.ManageMembers];

export const ROLE_PERMISSIONS: Readonly<Record<BlogRole, readonly BlogPermission[]>> = {
  [BlogRole.Viewer]: VIEWER,
  [BlogRole.Editor]: EDITOR,
  [BlogRole.Owner]: OWNER,
};

export function roleHasPermission(role: BlogRole, permission: BlogPermission): boolean {
  return ROLE_PERMISSIONS[role].includes(permission);
}
